import { Link, Text } from '@billy/design-system'
import { ReactElement } from 'react'

import { useOrganizationViewUrl } from '../../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../../utils/routing/reactRoute'

interface DocumentCustomerLinkProps {
  displayName?: string | null
  externalContactId?: string | null
}

export const DocumentCustomerLink = ({
  displayName,
  externalContactId,
}: DocumentCustomerLinkProps): ReactElement | null => {
  const { url: customerUrl } = useOrganizationViewUrl(
    reactRoute.organization.clients.getViewClientRoute(externalContactId ?? ''),
  )

  if (!displayName) {
    return null
  }

  return (
    <Text alignment="left" colorVariant="primary" variant="bodySM" weight="bold">
      <Link to={customerUrl} withAnimation>
        {displayName}
      </Link>
    </Text>
  )
}
